import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title d-flex"
}
const _hoisted_2 = { class: "filler" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = {
  key: 1,
  class: "footer"
}
const _hoisted_5 = { class: "text-center" }

import ChatModal from "~/chat/vue/widget/ChatModal.vue";
import CloseIcon from "~/chat/vue/misc/CloseIcon.vue";
import ChatScrollContainer from "~/chat/vue/misc/ChatScrollContainer.vue";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "ChatModalMessage"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    visible: { type: Boolean, default: false },
    title: {},
    withoutPadding: { type: Boolean },
    appendToBody: { type: Boolean },
    showCloseInTitle: { type: Boolean, default: true },
    showCloseInFooter: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

function close() {
    emits('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatModal, {
    "append-to-body": _ctx.appendToBody,
    visible: _ctx.visible,
    class: "has-content-border-radius",
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('update:visible', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['chat-modal', _ctx.appendToBody ? 'append-to-body' : 'append-to-widget', 'd-flex', 'vertical', 'content-border-radius-top', 'force-content-border-radius-bottom', _ctx.withoutPadding ? 'without-padding' : '']),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        style: {"height":"auto !important"}
      }, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
              (_ctx.showCloseInTitle)
                ? (_openBlock(), _createBlock(CloseIcon, {
                    key: 0,
                    class: "ml-4",
                    onClick: close
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(ChatScrollContainer, { class: "body" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        }),
        ((!_ctx.title && _ctx.showCloseInFooter !== false) || _ctx.showCloseInFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(ChatFormButton, {
                  inverse: true,
                  type: "primary",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(__)("CLOSE")), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 3
  }, 8, ["append-to-body", "visible"]))
}
}

})